/**
 * A map of signals that the initial response from the network has been received for a given relay query.
 *
 * This signal is used on the server-side during SSR to prevent React from running a render pass
 * until we can guarantee the data has arrived and is cached in the relay-client.
 *
 * This allows us to make a meaningful an initial render pass, avoiding needless suspense boundaries
 * and avoiding adding noncritical work to the JS call stack.
 */
export const QueryPromisesMap: Map<string, Promise<void>> = new Map<string, Promise<void>>();
/**
 * A map of signals that the response for a given relay query has completed and all data has been received.
 *
 * This signal is used on the server side to ensure we can wait for all incremental payloads
 * (e.g., any queries that used `@defer` or `@stream`) and ensure we flush them to the client
 * before closing the HTTP response stream.
 */
export const CompletedQueryPromisesMap: Map<string, Promise<void>> = new Map<
	string,
	Promise<void>
>();
